import React, { useEffect, useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { apiFetch } from "api/Api";
import BASE_URL from "api/Api";
import "assets/theme/admin_form.css";

const EditHeroSection = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    title: "",
    description: "",
    image: null,
  });

  const [existingImage, setExistingImage] = useState(null);
  const [preview, setPreview] = useState(null);
  const [loading, setLoading] = useState(false);

  // Fetch existing data
  const fetchHero = async () => {
    try {
      const res = await apiFetch(
        `leader_admin/get_hero_section_by_id/${id}`
      );

      const hero = res.data;

      setFormData({
        title: hero.title,
        description: hero.description,
        image: null,
      });

      setExistingImage(hero.image_url);

    } catch (error) {
      alert(error.message);
    }
  };

  useEffect(() => {
    fetchHero();
  }, []);

  const handleChange = (e) => {
    const { name, value, files } = e.target;

    if (name === "image") {
      const file = files[0];
      setFormData({ ...formData, image: file });

      if (file) {
        setPreview(URL.createObjectURL(file));
      }
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const data = new FormData();
      data.append("title", formData.title);
      data.append("description", formData.description);

      if (formData.image) {
        data.append("image", formData.image);
      }

      await apiFetch(
        `leader_admin/update_hero_section/${id}`,
        {
          method: "PUT",
          body: data,
        }
      );

      alert("Hero Section Updated Successfully");
      navigate("/hero_section_list");

    } catch (error) {
      alert(error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />

      <div className="container-fluid mt-4" style={{ fontSize: "0.9rem" }}>

        {/* Header Card */}
        <div className="admin-form-header-card">
          <div className="d-flex align-items-center gap-3">
            <button type="button" onClick={() => navigate(-1)} className="btn-admin-back">
              <FaArrowLeft />
              <span>मागे जा (Back)</span>
            </button>
            <div>
              <h4 className="fw-bold mb-1 text-white">
                ✏️ मुख्य बॅनर संपादन (Edit Hero Banner)
              </h4>
              <small className="text-white-50">Update home hero banner slider details</small>
            </div>
          </div>

          <Link to="/hero_section_list" className="btn btn-light btn-sm fw-semibold rounded-pill px-3">
            Banner List
          </Link>
        </div>

        {/* Form Card */}
        <div className="card border-0 shadow-lg rounded-4">
          <div className="card-body p-4">

            <form onSubmit={handleSubmit}>
              <div className="row g-4">

                {/* Title */}
                <div className="col-md-6">
                  <label className="form-label fw-semibold">
                    शीर्षक / Hero Title <span className="text-muted fw-normal">(ऐच्छिक / Optional)</span>
                  </label>
                  <input
                    type="text"
                    className="form-control shadow-sm"
                    name="title"
                    value={formData.title}
                    onChange={handleChange}
                  />
                </div>

                {/* Description */}
                <div className="col-12">
                  <label className="form-label fw-semibold">
                    वर्णन / Description <span className="text-muted fw-normal">(ऐच्छिक / Optional)</span>
                  </label>
                  <textarea
                    className="form-control shadow-sm"
                    rows="4"
                    name="description"
                    value={formData.description}
                    onChange={handleChange}
                  />
                </div>

                {/* Existing Image */}
                {existingImage && !preview && (
                  <div className="col-md-6">
                    <label className="form-label fw-semibold">
                      सध्याची प्रतिमा / Current Image
                    </label>
                    <div className="border rounded-3 p-2 shadow-sm">
                      <img
                        src={`${BASE_URL}/${existingImage}`}
                        alt="Current"
                        className="img-fluid rounded-3"
                        style={{ maxHeight: "200px", objectFit: "cover" }}
                      />
                    </div>
                  </div>
                )}

                {/* Upload New Image */}
                <div className="col-md-6">
                  <label className="form-label fw-semibold d-flex align-items-center justify-content-between">
                    <span>नवीन प्रतिमा बदला / Replace Hero Image <span className="text-danger">*</span></span>
                    <span className="badge bg-danger text-white fw-bold px-2 py-1" style={{ fontSize: "0.75rem" }}>
                      प्रतिमा आवश्यक आहे (Required *)
                    </span>
                  </label>
                  <input
                    type="file"
                    className="form-control shadow-sm"
                    name="image"
                    onChange={handleChange}
                    accept="image/*"
                    required={!existingImage}
                  />
                  <small className="text-danger fw-semibold d-block mt-1">
                    * बॅनरसाठी प्रतिमा असणे अनिवार्य आहे (Image is required).
                  </small>
                </div>

                {/* Preview New Image */}
                {preview && (
                  <div className="col-md-6">
                    <label className="form-label fw-semibold">
                      नवीन प्रतिमा पूर्वावलोकन / New Preview
                    </label>
                    <div className="border rounded-3 p-2 shadow-sm">
                      <img
                        src={preview}
                        alt="Preview"
                        className="img-fluid rounded-3"
                        style={{ maxHeight: "200px", objectFit: "cover" }}
                      />
                    </div>
                  </div>
                )}

              </div>

              {/* Submit Button */}
              <div className="d-flex justify-content-end mt-4 pt-3 border-top">
                <button
                  className="btn btn-primary px-5 py-2 fw-semibold"
                  style={{ fontSize: "0.85rem" }}
                  disabled={loading}
                >
                  {loading ? "Updating..." : "Update Hero"}
                </button>
              </div>

            </form>

          </div>
        </div>

      </div>
    </DashboardLayout>
  );
};

export default EditHeroSection;